<template>
  <div class="ion-page">
    <ion-header translucent>
      <ion-toolbar>
        <ion-title>Profiel</ion-title>
        <ion-buttons slot="primary">
          <ion-button @click="toggleReorder">
            <ion-icon name="reorder" size="large" slot="icon-only"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ProfileList>
    </ProfileList>
  </div>
</template>

<script>
  import ProfileList from '../components/Profile/ProfileList';

  export default {
    name: 'profile',
    components: {
      ProfileList
    },
    data() {
      return {
        info: null,
        i: 0,
      };
    },
    methods: {
      toggleReorder() {
        const reorderGroup = document.getElementById('reorder');
        reorderGroup.disabled = !reorderGroup.disabled;
        reorderGroup.addEventListener('ionItemReorder', ({ detail }) => {
          detail.complete(true);
        });
      },
    },
    created() {
      // this.toggleReorder();
    }
  };
</script>
